import { ToggleLeft } from "lucide-react";
import type React from "react";
import type { DataFieldBoolean } from "schema/agent";
import { Field } from "./Field";

export interface BooleanFieldProps {
  field: DataFieldBoolean;
  onChange: (value: boolean) => void;
}

export const BooleanField: React.FC<BooleanFieldProps> = ({ field, onChange }) => {
  return (
    <Field icon={ToggleLeft} label={field.label} visibleAt={field.visibleAt}>
      <button
        type="button"
        onClick={() => onChange(!field.value)}
        className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${
          field.value ? "bg-indigo-600" : "bg-slate-600"
        }`}
      >
        <span
          className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform ${
            field.value ? "translate-x-5" : "translate-x-1"
          }`}
        />
      </button>
    </Field>
  );
};
